import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrowdown",
  "use": "icon-arrowdown-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon-arrowdown\"><path fill=\"#CE3F4F\" d=\"m10.303 15.96-4.25-4.25c-1.285-1.285-1.927-1.928-1.97-2.48a1.5 1.5 0 0 1 .52-1.258c.421-.359 1.33-.359 3.147-.359h8.5c1.818 0 2.726 0 3.147.36a1.5 1.5 0 0 1 .521 1.258c-.043.551-.686 1.194-1.97 2.48l-4.25 4.249c-.595.594-.892.891-1.234 1.002a1.5 1.5 0 0 1-.927 0c-.343-.111-.64-.408-1.234-1.002\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol